import React from 'react';
const testimonials = [{
  initials: 'LG',
  name: 'Lucas G.',
  location: 'Buenos Aires · Emprendedor Digital',
  quote: 'Armé mi embudo completo en un fin de semana. El Tomo de Meta Ads me hizo ver todo lo que estaba tirando plata sin saber. En 3 semanas recuperé la inversión.'
}, {
  initials: 'VR',
  name: 'Valeria R.',
  location: 'Córdoba · Infoproductora',
  quote: 'Los scripts del Bono 1 me ahorraron semanas de trabajo. Adapté los textos en una tarde y lancé mi primera campaña al día siguiente. Ya tengo mis primeras ventas.'
}, {
  initials: 'MP',
  name: 'Martín P.',
  location: 'Rosario · Emprendedor Digital',
  quote: 'El Calendario de 90 Días me salvó la vida. Yo era de los que sabía todo pero no hacía nada. Tener el mapa día por día me sacó la parálisis de análisis para siempre.'
}];
const painPoints = ['Abrís Instagram y ves a alguien mostrando sus ventas del mes mientras vos seguís en cero', 'Compraste cursos que te dieron información pero nunca el mapa completo en orden', 'Configuraste anuncios, gastaste plata en Meta Ads y no vendiste nada', 'Tu landing page existe pero convierte al 0,5% cuando debería convertir al 3-5%', 'Sabés "algo" de cada cosa pero no sabés cómo integrar todo en un sistema que funcione', 'Fin de semana consumiendo contenido gratis en YouTube y el lunes volvés a empezar el mismo ciclo'];
export function ProblemSection() {
  return <section className="py-16 md:py-24 bg-[#0A0A0A]" data-id="element-132">
      <div className="max-w-6xl mx-auto px-4" data-id="element-133">
        {/* Testimonials */}
        <div className="grid md:grid-cols-3 gap-5 md:gap-6 mb-20 md:mb-28" data-id="element-134">
          {testimonials.map((t, i) => <div key={i} className="bg-neutral-900 border border-neutral-800 rounded-2xl p-6 hover:border-[#D4AF37]/40 transition-colors" data-id="element-135">
              <div className="flex items-center gap-3 mb-4" data-id="element-136">
                <div className="w-11 h-11 rounded-full bg-[#D4AF37]/10 text-[#D4AF37] flex items-center justify-center font-bold text-sm border border-[#D4AF37]/30" data-id="element-137">
                  {t.initials}
                </div>
                <div data-id="element-138">
                  <div className="text-[#D4AF37] text-xs tracking-wider mb-0.5" data-id="element-139">
                    ★★★★★
                  </div>
                  <div className="text-sm text-gray-400 font-medium" data-id="element-140">
                    {t.name}
                  </div>
                </div>
              </div>
              <p className="text-gray-300 italic leading-relaxed text-sm md:text-base" data-id="element-141">
                "{t.quote}"
              </p>
              <div className="mt-4 text-xs text-gray-600 font-medium" data-id="element-142">
                {t.location}
              </div>
            </div>)}
        </div>

        {/* Pain Points */}
        <div className="max-w-3xl mx-auto text-center mb-10 md:mb-12" data-id="element-143">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-144">
            ¿Cuántos lunes más vas a seguir viendo cómo otros venden online?
          </h2>
          <p className="text-lg md:text-xl text-gray-400 leading-relaxed" data-id="element-145">
            Querés tener tu negocio digital. Tenés las ganas. Pero nadie te dijo
            que ibas a pasar los domingos mirando cursos que no se conectan
            entre sí, los lunes sin saber por dónde empezar y los viernes
            sintiendo que consumiste contenido toda la semana y no implementaste
            nada.
          </p>
          <p className="text-lg md:text-xl text-[#D4AF37] font-semibold mt-6" data-id="element-146">
            No es falta de capacidad. Es falta de un sistema.
          </p>
        </div>

        <div className="max-w-3xl mx-auto bg-neutral-900/60 border border-neutral-800 rounded-2xl md:rounded-3xl p-6 md:p-10" data-id="element-147">
          <div className="space-y-5" data-id="element-148">
            {painPoints.map((point, i) => <div key={i} className="flex items-start gap-3 md:gap-4" data-id="element-149">
                <span className="text-red-500 text-lg mt-0.5 shrink-0" data-id="element-150">❌</span>
                <p className="text-base md:text-lg text-gray-300" data-id="element-151">{point}</p>
              </div>)}
          </div>
        </div>

        <div className="text-center mt-12 md:mt-16" data-id="element-152">
          <h3 className="text-2xl md:text-4xl font-bold text-white" data-id="element-153">
            ¿Y si este fuera el último lunes que empezás sin un sistema?
          </h3>
        </div>
      </div>
    </section>;
}